import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { DocumentoNoTributarioDetService } from 'src/app/services/documento-no-tributario-det.service';
import { DocumentoNoTributarioService } from 'src/app/services/documento-no-tributario.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-confirmar-nota-venta-modal-ver-pedido',
  templateUrl: './modal-ver-pedido.component.html',
  styleUrls: ['../confirmar-nota-venta.component.scss'],
  providers: [SecurityService]
})
export class ConfirmarNotaVentaModalVerPedidoComponent implements OnInit {

  @ViewChild('verPedido', { static: true }) verPedidoModal: ModalDirective;

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  loading: boolean = false
  listaMovimientos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  movimiento: any

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private documentoNoTributarioService: DocumentoNoTributarioService,
    private documentoNoTributarioDetService: DocumentoNoTributarioDetService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
  ) {
    this.log = this.clog.log('VER-PEDIDOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
  }

  loadAndShow(mov) {
    this.log('loadAndShow', mov)
    this.movimiento = mov
    this.verPedidoModal.show()
    this.buscar(1)
  }

  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null

    const inputParams = {
      rut_empresa: this.rutEmpresa,
      folio: this.movimiento.folio,
      tipo_dte_codigo: this.movimiento.tipo_dte_codigo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.documentoNoTributarioDetService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaMovimientos = registros

      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

}
